import React, { useState, useEffect } from 'react';
import { Box, Typography, Dialog, IconButton } from '@mui/material';
import { ChevronLeft, ChevronRight, Close as CloseIcon } from '@mui/icons-material';

const RoomImageCarousel = ({ room, open, onClose }) => {
  const imgs = room?.imageUrls?.length ? room.imageUrls : (room?.imageUrl ? [room.imageUrl] : []);
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    if (open) setIdx(0);
  }, [open]);

  if (imgs.length === 0) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth={false} PaperProps={{ sx: { borderRadius: 2, overflow: 'hidden' } }}>
      <Box sx={{ position: 'relative', minWidth: 360, maxWidth: 640 }}>
        <IconButton
          onClick={onClose}
          sx={{ position: 'absolute', top: 8, right: 8, zIndex: 1, bgcolor: 'rgba(0,0,0,0.5)', color: 'white', '&:hover': { bgcolor: 'rgba(0,0,0,0.7)' } }}
        >
          <CloseIcon />
        </IconButton>
        <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
          <IconButton
            onClick={() => setIdx((i) => (i - 1 + imgs.length) % imgs.length)}
            sx={{ position: 'absolute', left: 8, zIndex: 1, bgcolor: 'rgba(0,0,0,0.3)', color: 'white', '&:hover': { bgcolor: 'rgba(0,0,0,0.5)' } }}
          >
            <ChevronLeft />
          </IconButton>
          <Box
            component="img"
            src={imgs[idx]}
            alt={`${room?.name} ${idx + 1}`}
            sx={{ width: '100%', maxHeight: 480, objectFit: 'contain' }}
          />
          <IconButton
            onClick={() => setIdx((i) => (i + 1) % imgs.length)}
            sx={{ position: 'absolute', right: 8, zIndex: 1, bgcolor: 'rgba(0,0,0,0.3)', color: 'white', '&:hover': { bgcolor: 'rgba(0,0,0,0.5)' } }}
          >
            <ChevronRight />
          </IconButton>
        </Box>
        <Box sx={{ py: 2, px: 2, bgcolor: 'var(--color-charcoal)', color: 'white' }}>
          <Typography variant="h6">{room?.name}</Typography>
          <Typography variant="caption">{idx + 1} / {imgs.length}</Typography>
        </Box>
      </Box>
    </Dialog>
  );
};

export default RoomImageCarousel;
